if (!customElements.get('cart-enhancements')) {
  customElements.define(
    'cart-enhancements',
    class CartEnhancements extends HTMLElement {
      connectedCallback() {
        if (this.dataset.location !== 'page') return;

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCartFooter());
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      refreshCartFooter() {
        const currentContents = this.closest('.js-contents');
        if (!currentContents) return;

        fetch(`${routes.cart_url}?section_id=main-cart-footer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const updatedContents = html.querySelector('#main-cart-footer .js-contents');
            if (updatedContents) currentContents.innerHTML = updatedContents.innerHTML;
          })
          .catch((error) => console.error(error));
      }
    }
  );
}

if (!customElements.get('cart-recommendations')) {
  customElements.define(
    'cart-recommendations',
    class CartRecommendations extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url || this.loaded) return;
        this.loaded = true;
        this.addEventListener('click', (event) => this.onAddToCart(event));

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const results = html.querySelector('#CartRecommendationsResults');
            if (!results) {
              this.remove();
              return;
            }

            const cartProductIds = new Set(
              (this.dataset.cartProductIds || '')
                .split(',')
                .filter(Boolean)
            );
            results.querySelectorAll('[data-product-id]').forEach((product) => {
              if (cartProductIds.has(product.dataset.productId)) product.remove();
            });

            if (!results.querySelector('[data-product-id]')) {
              this.remove();
              return;
            }

            this.innerHTML = results.innerHTML;
            this.classList.add('cart-recommendations--loaded');
          })
          .catch((error) => {
            console.error(error);
            this.remove();
          });
      }

      onAddToCart(event) {
        const button = event.target.closest('[data-cart-upsell-add]');
        if (!button || button.getAttribute('aria-disabled') === 'true') return;

        event.preventDefault();
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!cart) return;

        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        button.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          items: [{ id: button.dataset.variantId, quantity: 1 }],
          sections: cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) throw new Error(response.description || response.message);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: response });
            cart.renderContents(response);
          })
          .catch((error) => console.error(error))
          .finally(() => {
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            button.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          });
      }
    }
  );
}

if (!customElements.get('cart-recommendation-carousel')) {
  customElements.define(
    'cart-recommendation-carousel',
    class CartRecommendationCarousel extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.cart-recommendations__list');
        this.items = this.querySelectorAll('.cart-recommendations__item');
        this.previous = this.querySelector('[name="previous"]');
        this.next = this.querySelector('[name="next"]');
        if (!this.list || this.items.length < 2) {
          this.querySelector('.cart-recommendations__controls')?.remove();
          return;
        }
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
      }

      move(direction) {
        const amount = this.items[0].getBoundingClientRect().width + 12;
        const atStart = this.list.scrollLeft <= 2;
        const atEnd = this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 2;
        if ((direction < 0 && atStart) || (direction > 0 && atEnd)) {
          this.list.scrollTo({ left: direction < 0 ? this.list.scrollWidth : 0, behavior: 'smooth' });
          return;
        }
        this.list.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }
    }
  );
}
